import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Image from 'components/Image';
import Slider from 'react-slick';
//import { rodate } from 'utils/common';
import s from './VideoTheater.scss';

function getImage(data) {
  let imgSrc = 'https://static.toiimg.com/photo/34824568.cms';
  let imgElements;
  if (
    data.imageid &&
    data.imageid.indexOf('https://static.toiimg.com') !== -1
  ) {
    imgSrc = data.imageid;
  } else if (data.imageid) {
    imgElements = data.imageid.split('&');
    if (imgElements.length > 1) {
      imgSrc = `https://static.toiimg.com/thumb/msid-${imgElements[0]},${
        imgElements[1]
      },width-280,resizemode-4/${imgElements[0]}.jpg`;
    } else {
      imgSrc = `https://static.toiimg.com/photo/msid-${
        imgElements[0]
      },width-280,resizemode-4/${imgElements[0]}.jpg`;
    }
  } else {
    imgSrc = `https://static.toiimg.com/photo/msid-${
      data.id
    },width-280,resizemode-4/${data.id}.jpg`;
  }
  return (
    <Image
      src={imgSrc}
      alt={data.hl}
      // lazyload
      placeHolderSrc="https://static.toiimg.com/photo/34824568.cms"
      offsetVertical={100}
    />
  );
}
// function getLatestDateString(data) {
//   const latestDate = data.upd || data.lpt || data.dl;
//   const latestDateRelativeString = rodate(latestDate);
//   return latestDateRelativeString;
// }
class VideoTheaterSlider extends React.Component {
  constructor() {
    super();
    this.sliderRef = React.createRef();
  }

  render() {
    const {
      isWapView,
      items,
      handleSliderCardItem,
      activeSlide,
      isTablet,
    } = this.props;
    if (!isWapView && items) {
      const settings = {
        slidesToShow:
          isTablet && isTablet() ? 4 : Math.round(window.outerWidth / 178),
        slidesToScroll:
          isTablet && isTablet() ? 4 : Math.round(window.outerWidth / 178),
        pauseOnHover: false,
        pauseOnFocus: false,
        dots: false,
        arrows: true,
        swipeToSlide: true,
        autoplay: false,
        draggable: false,
        infinite: false,
      };
      return (
        <div className={`${s.trendingvdo}`}>
          <Slider {...settings} ref={this.sliderRef}>
            {items &&
              items.map(item => (
                <div
                  className={`${s.parentContainer} ${
                    activeSlide === item.id ? s.active : ''
                  } ${item.primeid ? s.prime : ''}`}
                >
                  <Link
                    to={item.wu || item.su}
                    className=""
                    title={item.hl}
                    spa
                    onClick={e => handleSliderCardItem(e, item)}
                  >
                    <div className={s.vdothumb}>
                      <div className={s.content}>
                        {getImage(item)}
                        <span className={s.playicon}>{item.du}</span>
                      </div>
                    </div>
                    <div className={s.vdoinfo}>
                      <span className={s.discription}>{item.hl}</span>
                      {/* <span className={s.time}>
                        {getLatestDateString(item)}
                      </span> */}
                    </div>
                  </Link>
                </div>
              ))}
          </Slider>
        </div>
      );
    }
    return '';
  }
}
VideoTheaterSlider.propTypes = {
  isWapView: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  handleSliderCardItem: PropTypes.func.isRequired,
  isTablet: PropTypes.func,
};

VideoTheaterSlider.defaultProps = {
  isWapView: false,
  items: [],
  isTablet: undefined,
};

export default VideoTheaterSlider;
